<div class="radio-container">
    <div class="radio-player">
        <iframe
                title="Live radio"
                src="https://radio.9craft.ir"
                allow="autoplay"
        ></iframe>
    </div>
</div>

<style>
    .radio-container {
        max-width: 900px;
    }

    .radio-player {
        background: rgba(255, 255, 255, 0.08);
        border-radius: 24px;
        overflow: hidden;
        border: 1px solid var(--glass-border);
        margin-bottom: 32px;
        box-shadow: var(--glass-shadow);
        backdrop-filter: blur(20px) saturate(1.8);
        -webkit-backdrop-filter: blur(20px) saturate(1.8);
        height: 700px;
    }

    .radio-player iframe {
        width: 100%;
        height: 100%;
        border: none;
    }
</style>